import { LOGIN_SUCCESS, LOGOUT } from '../types/types';

const initialState = {
	user: null,
	loading: false,
	isAuthenticated: false,
	ACCESS_TOKEN: null,
	accessTokenExpirationDate: null,
	REFRESH_TOKEN: null,
	error: null,
	firstTimeUser: true,
	datefirstTimeUserLogin: null
};

export default function authReducer(state = initialState, action: any = {}) {
	switch (action.type) {
		case LOGIN_SUCCESS:
			return {
				...state,
				user: action.payload,
				ACCESS_TOKEN: action.payload.accessToken,
				accessTokenExpirationDate: action.payload.accessTokenExpirationDate,
				REFRESH_TOKEN: action.payload.refreshToken,
				isAuthenticated: true,
				loading: false,
				error: null,
				firstTimeUser: false,
				datefirstTimeUserLogin: new Date()
			};
		case LOGOUT:
			return {
				user: null,
				loading: false,
				isAuthenticated: false,
				ACCESS_TOKEN: null,
				accessTokenExpirationDate: null,
				REFRESH_TOKEN: null,
				error: null
			};
		default:
			return state;
	}
}
